import React from "react";
// import "./MethodologyPage.css";

const MethodologyPage = () => {
  return (
    <div className="methodology-container">
      
      {/* LEFT SIDE */}
      <div className="methodology-content">
        <h2>Methodology</h2>
        <p>
          The Transparency in Corporate Reporting (TRAC) Assessment 2024 is an
          assessment of corporate disclosure practices among the top 70 public
          listed companies in Pakistan. The research methodology draws on
          Transparency International’s standard TRAC methodology and is
          consistent with TRAC reports published in other countries.
        </p>

        <h2>TRAC’s Central Purpose</h2>
        <p>
          TRAC evaluates corporate transparency by analyzing key metrics that
          reflect a company’s commitment to disclosure practices. These
          practices are essential for building stakeholder trust and fostering a
          culture of accountability. They enable stakeholders to assess how
          effectively companies align their reporting with established
          standards while ensuring that potential risk areas are proactively
          addressed.
        </p>
<p>
        TRAC evaluates corporate transparency by analyzing key metrics that reflect a company’s commitment to disclosure practices. These practices are essential for building stakeholder trust and fostering a culture of accountability. They enable stakeholders to assess how effectively companies align their reporting with established standards while ensuring that potential risk areas are proactively addressed.
      </p>
        
      </div>

      {/* RIGHT SIDE */}
      <div className="methodology-image">
  <img
    src="https://transparency.org.pk/event-2024-2025/wp-content/uploads/2025/02/TRAC-Report-2024-1.jpg"
    alt="TRAC Report 2024"
  />
  {/* Download Button */}
        <a
            href="https://transparency.org.pk/PUBLICATION/Transparency-in-corporate-reporting-2024.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="download-button"
        >
            Download Here
        </a>
        </div>
    </div>
  );
};

export default MethodologyPage;